import { createAsyncThunk } from '@reduxjs/toolkit';

import { del, get, put, post } from './http';
import { activeSnack } from '../store/common';

export const createEnquiryCategory = createAsyncThunk(
  'enquiry-category/create',
  async ({ state, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/enquiry-category/admin/new`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(
          getAllEnquiryCategorys({
            page: 1,
            search: '',
            dispatch,
            limit: sessionStorage.getItem('rowsPerPage_enquiry_category'),
            district: '',
          })
        );
        dispatch(activeSnack({ type: 'success', message: 'Enquiry Category created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getAllEnquiryCategorys = createAsyncThunk(
  'enquiry-category/list',
  async ({ page, search, dispatch, limit }) => {
    try {
      const response = await get(
        `/enquiry-category/admin/all?page=${page && page}&search=${search && search}&limit=${limit || 5}`
      );
      // console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const getEnquiryCategoryDetails = createAsyncThunk(
  'enquiry-category/single',
  async ({ enquiryCategoryId, dispatch }) => {
    try {
      // console.log('ID:', enquiryCategoryId);
      const response = await get(`/enquiry-category/admin/${enquiryCategoryId}`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const updateEnquiryCategoryDetails = createAsyncThunk(
  'enquiry-category/update',
  async ({ state, enquiryCategoryId, dispatch, handleClose, handleClear }) => {
    try {
      const URL = `/enquiry-category/admin/${enquiryCategoryId}`;

      const response = await put(URL, state);
      if (response) {
        if (handleClose) {
          handleClose();
        }
        if (handleClear) {
          handleClear();
        }
        dispatch(
          getAllEnquiryCategorys({
            page: 1,
            search: '',
            dispatch,
            limit: sessionStorage.getItem('rowsPerPage_enquiry_category'),
            district: '',
          })
        );
        dispatch(activeSnack({ type: 'success', message: 'Enquiry Category updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);

export const deleteEnquiryCategory = createAsyncThunk('enquiry-category/delete', async ({ enquiryCategoryId, dispatch }) => {
  try {
    const response = await del(`/enquiry-category/admin/${enquiryCategoryId}`);
    if (response) {
      dispatch(activeSnack({ type: 'success', message: 'Enquiry Category deleted Successfully' }));
      return response?._id;
    }
    return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
  } catch (error) {
    dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
    throw error?.response?.data?.message;
  }
});
